module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "manage_app p_background clearfix"
  }, [_c('h3', {
    staticClass: "all_title"
  }, [_vm._v("应用审核列表")]), _vm._v(" "), _c('section', {
    staticClass: "all_container container_box"
  }, [_c('div', {
    staticClass: "all_state clearfix"
  }, [_c('div', {
    staticClass: "state_left"
  }, [_c('ul', [_c('li', {
    staticClass: "state_active",
    attrs: {
      "id": "manage_all"
    },
    on: {
      "click": function($event) {
        return _vm.getAppCheckAuditList($event, 0)
      }
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "manage_daishen"
    },
    on: {
      "click": function($event) {
        return _vm.getAppCheckAuditList($event, 1)
      }
    }
  }, [_vm._v("等待审核(" + _vm._s(_vm.counts.daishenCount) + ")")]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "manage_zaishou"
    },
    on: {
      "click": function($event) {
        return _vm.getAppCheckAuditList($event, 2)
      }
    }
  }, [_vm._v("正在销售(" + _vm._s(_vm.counts.zaishouCount) + ")")]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "manage_beijin"
    },
    on: {
      "click": function($event) {
        return _vm.getAppCheckAuditList($event, 3)
      }
    }
  }, [_vm._v("被禁应用(" + _vm._s(_vm.counts.beijinCount) + ")")])])]), _vm._v(" "), _c('div', {
    staticClass: "state_center text-right"
  }, [_c('section', {
    staticClass: "search_box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.appName),
      expression: "appName",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "search_control",
    attrs: {
      "id": "manage_app_query",
      "type": "text",
      "placeholder": "输入应用名称查询"
    },
    domProps: {
      "value": (_vm.appName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.queryApp.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.appName = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "glyphicon icon_search",
    on: {
      "click": function($event) {
        return _vm.queryApp()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "table_box user-select clearfix"
  }, [_c('table', {
    staticClass: "table table-hover text-center"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.page.content), function(item) {
    return _c('tr', [(item.delFlag == 0) ? _c('td', {
      staticClass: "text-left"
    }, [_c('div', {
      staticClass: "inline-block apply_thumbnail cursor",
      on: {
        "click": function($event) {
          return _vm.queryAppDetails(item.id, item.appVersionNo, 1)
        }
      }
    }, [_c('img', {
      staticClass: "img_default",
      attrs: {
        "src": item.filePath,
        "alt": ""
      }
    })]), _vm._v(" "), _c('a', {
      staticClass: "cursor",
      on: {
        "click": function($event) {
          return _vm.queryAppDetails(item.id, item.appVersionNo, 1)
        }
      }
    }, [_vm._v(_vm._s(item.appName))])]) : (item.appStatus == '3') ? _c('td', {
      staticClass: "text-left"
    }, [_c('div', {
      staticClass: "inline-block apply_thumbnail cursor",
      on: {
        "click": function($event) {
          return _vm.queryAppDetails(item.id, item.appVersionNo, 1)
        }
      }
    }, [_c('img', {
      staticClass: "img_default",
      attrs: {
        "src": item.filePath,
        "alt": ""
      }
    })]), _vm._v(" "), _c('a', {
      staticClass: "cursor",
      on: {
        "click": function($event) {
          return _vm.queryAppDetails(item.id, item.appVersionNo, 1)
        }
      }
    }, [_vm._v(_vm._s(item.appName))])]) : (item.inspectStatus == '0') ? _c('td', {
      staticClass: "text-left"
    }, [_c('div', {
      staticClass: "inline-block apply_thumbnail cursor",
      on: {
        "click": function($event) {
          return _vm.queryAppDetails(item.id, item.appVersionNo, 0)
        }
      }
    }, [_c('img', {
      staticClass: "img_default",
      attrs: {
        "src": item.filePath,
        "alt": ""
      }
    })]), _vm._v(" "), _c('a', {
      staticClass: "cursor",
      on: {
        "click": function($event) {
          return _vm.queryAppDetails(item.id, item.appVersionNo, 0)
        }
      }
    }, [_vm._v(_vm._s(item.appName))])]) : (item.inspectStatus == '3') ? _c('td', {
      staticClass: "text-left"
    }, [_c('div', {
      staticClass: "inline-block apply_thumbnail cursor",
      on: {
        "click": function($event) {
          return _vm.queryAppDetails(item.id, item.appVersionNo, 0)
        }
      }
    }, [_c('img', {
      staticClass: "img_default",
      attrs: {
        "src": item.filePath,
        "alt": ""
      }
    })]), _vm._v(" "), _c('a', {
      staticClass: "cursor",
      on: {
        "click": function($event) {
          return _vm.queryAppDetails(item.id, item.appVersionNo, 0)
        }
      }
    }, [_vm._v(_vm._s(item.appName))])]) : (item.inspectStatus == '9') ? _c('td', {
      staticClass: "text-left"
    }, [_c('div', {
      staticClass: "inline-block apply_thumbnail cursor",
      on: {
        "click": function($event) {
          return _vm.queryAppDetails(item.id, item.appVersionNo, 1)
        }
      }
    }, [_c('img', {
      staticClass: "img_default",
      attrs: {
        "src": item.filePath,
        "alt": ""
      }
    })]), _vm._v(" "), _c('a', {
      staticClass: "cursor",
      on: {
        "click": function($event) {
          return _vm.queryAppDetails(item.id, item.appVersionNo, 1)
        }
      }
    }, [_vm._v(_vm._s(item.appName))])]) : (item.inspectStatus == '2') ? _c('td', {
      staticClass: "text-left"
    }, [_c('div', {
      staticClass: "inline-block apply_thumbnail cursor",
      on: {
        "click": function($event) {
          return _vm.queryAppDetails(item.id, item.appVersionNo, 1)
        }
      }
    }, [_c('img', {
      staticClass: "img_default",
      attrs: {
        "src": item.filePath,
        "alt": ""
      }
    })]), _vm._v(" "), _c('a', {
      staticClass: "cursor",
      on: {
        "click": function($event) {
          return _vm.queryAppDetails(item.id, item.appVersionNo, 1)
        }
      }
    }, [_vm._v(_vm._s(item.appName))])]) : (item.appStatus == '2') ? _c('td', {
      staticClass: "text-left"
    }, [_c('div', {
      staticClass: "inline-block apply_thumbnail cursor",
      on: {
        "click": function($event) {
          return _vm.queryAppDetails(item.id, item.appVersionNo, 1)
        }
      }
    }, [_c('img', {
      staticClass: "img_default",
      attrs: {
        "src": item.filePath,
        "alt": ""
      }
    })]), _vm._v(" "), _c('a', {
      staticClass: "cursor",
      on: {
        "click": function($event) {
          return _vm.queryAppDetails(item.id, item.appVersionNo, 1)
        }
      }
    }, [_vm._v(_vm._s(item.appName))])]) : _c('td', {
      staticClass: "text-left"
    }, [_c('div', {
      staticClass: "inline-block apply_thumbnail cursor",
      on: {
        "click": function($event) {
          return _vm.queryAppDetails(item.id, item.appVersionNo, 1)
        }
      }
    }, [_c('img', {
      staticClass: "img_default",
      attrs: {
        "src": item.filePath,
        "alt": ""
      }
    })]), _vm._v(" "), _c('a', {
      staticClass: "cursor",
      on: {
        "click": function($event) {
          return _vm.queryAppDetails(item.id, item.appVersionNo, 1)
        }
      }
    }, [_vm._v(_vm._s(item.appName))])]), _vm._v(" "), (item.appStatus == '1' && item.inspectStatus == '1') ? _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(item.appVersionNo) + "\n\t\t\t\t\t\t\t")]) : _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(item.appVersionNo) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), (item.delFlag == 0) ? _c('td', [_vm._v("已删除")]) : (item.appStatus == '3') ? _c('td', {
      staticClass: "color_24bb19"
    }, [_vm._v("禁止销售")]) : (item.inspectStatus == '0') ? _c('td', {
      staticClass: "color_2993ff"
    }, [_vm._v("等待审核")]) : (item.inspectStatus == '9') ? _c('td', {
      staticClass: "color_ff1212"
    }, [_vm._v("等待提交")]) : (item.inspectStatus == '2') ? _c('td', {
      staticClass: "color_2993ff"
    }, [_vm._v("审核不通过")]) : (item.inspectStatus == '3') ? _c('td', {
      staticClass: "color_2993ff"
    }, [_vm._v("正在审核")]) : (item.appStatus == '2') ? _c('td', {
      staticClass: "color_24bb19"
    }, [_vm._v("暂停销售")]) : (item.inspectStatus == '1' && item.appStatus == '1' && item.publishStatus != '1') ? _c('td', {
      staticClass: "color_24bb19"
    }, [_vm._v("等待发布")]) : (item.inspectStatus == '1' && item.appStatus == '1' && item.publishStatus == '1') ? _c('td', {
      staticClass: "color_24bb19"
    }, [_vm._v("可供销售")]) : _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("time")(item.inputTime)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.chName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.businessTypeString))]), _vm._v(" "), (item.delFlag == 0) ? _c('td', [_vm._v("-")]) : (item.appStatus == '3') ? _c('td', [_c('a', {
      staticClass: "cursor",
      on: {
        "click": function($event) {
          return _vm.jiejin(item.id)
        }
      }
    }, [_vm._v("解除禁止")])]) : (item.inspectStatus == '0') ? _c('td', [_c('a', {
      staticClass: "cursor",
      on: {
        "click": function($event) {
          return _vm.queryAppDetails(item.id, item.appVersionNo, 0)
        }
      }
    }, [_vm._v("开始审核")])]) : (item.inspectStatus == '2') ? _c('td', [_vm._v("-")]) : (item.inspectStatus == '3') ? _c('td', [_c('a', {
      staticClass: "cursor",
      on: {
        "click": function($event) {
          return _vm.queryAppDetails(item.id, item.appVersionNo, 0)
        }
      }
    }, [_vm._v("开始审核")])]) : (item.inspectStatus == '9') ? _c('td', [_vm._v("-")]) : (item.appStatus == '2') ? _c('td', [_c('a', {
      staticClass: "cursor",
      on: {
        "click": function($event) {
          return _vm.jinzhiVal(item.id, item.appName)
        }
      }
    }, [_vm._v("禁止销售")])]) : (item.inspectStatus == '1' && item.appStatus == '1') ? _c('td', [_c('a', {
      staticClass: "cursor",
      on: {
        "click": function($event) {
          return _vm.jinzhiVal(item.id, item.appName)
        }
      }
    }, [_vm._v("禁止销售")])]) : _c('td', [_vm._v("-")])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    class: _vm.page.totalPages > 0 ? 'show' : 'hidden'
  }, [_c('div', {
    staticClass: "row-fluid"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 20, 30, 40],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.page.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.publishStatus),
      expression: "publishStatus"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.publishStatus)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.publishStatus = $event.target.value
      }
    }
  }), _vm._v(" "), _c('v-tip'), _vm._v(" "), (_vm.confirmFlag) ? _c('v-confirm', {
    attrs: {
      "bigMsg": _vm.bigMsg
    },
    on: {
      "confirmOff": function($event) {
        _vm.confirmFlag = !_vm.confirmFlag
      },
      "confirmTrue": _vm.jinzhi
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("应用名称")]), _vm._v(" "), _c('th', [_vm._v("版本编号")]), _vm._v(" "), _c('th', [_vm._v("状态")]), _vm._v(" "), _c('th', [_vm._v("申请时间")]), _vm._v(" "), _c('th', [_vm._v("申请人")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("操作")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-1b5b6160"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/manage_app.vue
// module id = 1242
// module chunks = 1